import styled from 'styled-components';

const SectionLink = styled.a`
  font-weight: 900;
  color: ${props => (props.active ? '#000' : '#999')};
  font-size: 26px;
  line-height: 32px;
  width: auto;
  cursor: pointer;
  text-align: center;
  flex: 1;
  &:hover {
    color: ${props => (props.active ? '#000' : '#999')};
    text-decoration: ${props => (props.active ? 'underline' : 'none')};
  }
`;

export default SectionLink;
